import { Dialog, DialogContent, DialogTitle, Slide, useMediaQuery, useTheme } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Image } from "../../../shared/components/styled/Container.styled";
import React, { useContext, useEffect, useState } from "react";
import { ConfiguratorContext } from "../../../contexts/ConfiguratorContext";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  ADVERT_HYPERLINK_KEY,
  ADVERT_IMAGE_KEY,
  ADVERT_MESSAGE_KEY,
} from "../../../shared/constants/Configurator.constants";
import { downloadFile } from "../../../data/configAPI";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LoginAdvertPopup = ({ open = false, setOpen = () => {}}) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { edittedFields, addNewEdittedField } = useContext(ConfiguratorContext);
  const { token } =
    useContext(AuthContext);
  const [imageAdvert, setImageAdvert] = useState(undefined);
  const [renderedImageAdvert, setRenderedImageAdvert] =
    useState(undefined);
  const [messageAdvert, setMessageAdvert] = useState(undefined);
  const [hyperlinkAdvert, setHyperlinkAdvert] = useState(undefined);
  const [imageAdvertRequestLoading, setImageAdvertRequestLoading] =
    useState(false);

  useEffect(() => {
    fillConfiguratorFields(edittedFields);
  }, [edittedFields]);

  useEffect(() => {
    const getAdvertData = async () => {
      if (token) {
        const currentAdvertImage = edittedFields.find(
          (item) => item.key === ADVERT_IMAGE_KEY,
        );
        if (currentAdvertImage) {
          setImageAdvert(currentAdvertImage.value);
        } else {
          if (!imageAdvertRequestLoading) {
            callImageApi(token);
          }
        }
      }
    };
    getAdvertData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, edittedFields]);



  useEffect(() => {
    if (!imageAdvert) {
      setRenderedImageAdvert(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(imageAdvert);
    setRenderedImageAdvert(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [imageAdvert]);

  const fillConfiguratorFields = (fields) => {
    fields.forEach((item) => {
      switch (item.key) {
        case ADVERT_IMAGE_KEY:
          setImageAdvert(item.value);
          return;
        case ADVERT_MESSAGE_KEY:
          setMessageAdvert(item.value);
          return;
        case ADVERT_HYPERLINK_KEY:
          setHyperlinkAdvert(item.value);
          return;
        default:
          return;
      }
    });
  };

  const callImageApi = async (token) => {
    setImageAdvertRequestLoading(true);
    const imageData = await downloadFile(token, ADVERT_IMAGE_KEY);
    if (imageData?.type?.includes("image")) {
      addNewEdittedField({
        key: ADVERT_IMAGE_KEY,
        value: imageData,
        modified: false,
      });
      setImageAdvert(imageData);
    }
    setImageAdvertRequestLoading(false);
  };

  const handleCloseLoginAdvert = () => {
    setOpen(false);
  };

  return (
    <>
     {messageAdvert !== "" || imageAdvert != null ? (
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseLoginAdvert}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
          maxWidth={isMobile ? "xs" : "sm"}
          sx={{
            '& .MuiDialog-paper': {
              margin: isMobile ? '16px' : '24px',
              // width: isMobile ? 'max-content' : 'auto',
              width: 'clamp(200px, 70vw, 600px)',

              maxWidth: isMobile ? 'none' : '600px',
            }
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: `${messageAdvert !== "" ? "space-between" : "flex-end"}`,
              alignItems: "flex-start",
              padding: isMobile ? "16px" : "24px",
              fontSize: isMobile ? "1rem" : "1.25rem",
            }}
          >
            {hyperlinkAdvert !== "" ? (
              <a
                href={hyperlinkAdvert}
                target="_blank"
                rel="noreferrer"
                style={{
                  textDecoration: "none",
                  color: "black",
                  fontSize: isMobile ? "0.875rem" : "1rem",
                }}
              >
                {messageAdvert}
              </a>
            ) : (
              <span style={{ fontSize: isMobile ? "0.875rem" : "1rem" }}>
                {messageAdvert}
              </span>
            )}

            <CloseOutlinedIcon
              sx={{
                cursor: "pointer",
                fontSize: isMobile ? "1.25rem" : "1.5rem",
                marginLeft: '8px'
              }}
              onClick={handleCloseLoginAdvert}
            />
          </DialogTitle>
          <DialogContent
            sx={{
              padding: isMobile ? "0 16px 16px" : "0 24px 24px",
              width: '100%'
            }}
          >
            {hyperlinkAdvert !== "" ? (
              <a href={hyperlinkAdvert} target="_blank" rel="noreferrer">
                <Image 
                  src={renderedImageAdvert} 
                  alt="Image Advert"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    // maxHeight: isMobile ? '300px' : '400px',
                    objectFit: 'contain',
                  }}
                />
              </a>
            ) : (
              <Image 
                src={renderedImageAdvert} 
                alt="Image Advert"
                sx={{
                  width: '100%',
                  height: 'auto',

                  // maxHeight: isMobile ? '300px' : '400px',
                  objectFit: 'contain',
                }}
              />
            )}
          </DialogContent>
        </Dialog>
      ) : ("")}
    </>
  )
}

export default LoginAdvertPopup;